import getMainMetaData from './getMainMetaData';
import trackingPages from './visitsTracking/trackingPages';

export default (data) => {
    let value;
    switch (data.name) {
        case 'CLS':
            value = data.value * 1000;
            break;
        default:
            value = data.value;
    }

    return {
        type: data.name,
        source: data.source,
        value: Math.round(value),
        userAgent: window.navigator.userAgent,
        ...trackingPages(),
        ...getMainMetaData({
            timestamp: (new Date()).getTime(),
        }),
    };
};